<template>
  <div
    class="overflow-x-auto w-full border border-gray-200 rounded-lg animate-pulse"
    data-testid="check-validation-table-skeleton"
  >
    <div class="w-max min-w-full">
      <div
        class="hidden md:grid gap-2 px-4 py-2"
        :style="{ gridTemplateColumns: GRID_TEMPLATE_COLUMNS, background: '#FAFAFA' }"
      >
        <!-- Coluna de seleção -->
        <div class="px-2"></div>
        <div
          v-for="(width, idx) in HEADER_WIDTHS"
          :key="`head-${idx}`"
          class="px-2 flex items-center"
          :class="isCenteredHeader(idx) ? 'justify-center' : 'justify-start'"
        >
          <div class="h-4 bg-slate-200 rounded" :class="width"></div>
        </div>
        <!-- Coluna de ações -->
        <div class="px-2"></div>
      </div>

      <div
        v-for="row in rows"
        :key="`row-${row}`"
        class="grid gap-2 items-center py-4 px-4 border-b border-gray-100 last:border-0"
        :style="{ gridTemplateColumns: GRID_TEMPLATE_COLUMNS }"
      >
        <!-- Checkbox de seleção -->
        <div class="flex items-center justify-center">
          <div class="h-5 w-5 rounded bg-slate-200"></div>
        </div>

        <!-- Registro (#checkId) -->
        <div class="h-3.5 w-8 bg-slate-200 rounded"></div>

        <!-- Médico: avatar + nome + CRM -->
        <div class="flex items-center gap-3">
          <div class="h-9 w-9 rounded-full bg-slate-200 shrink-0"></div>
          <div class="flex flex-col gap-1.5">
            <div class="h-3.5 w-28 bg-slate-200 rounded"></div>
            <div class="h-3 w-16 bg-slate-200 rounded"></div>
          </div>
        </div>

        <!-- Unidade · Escala -->
        <div class="flex flex-col gap-1.5">
          <div class="h-3.5 w-24 bg-slate-200 rounded"></div>
          <div class="h-3 w-16 bg-slate-200 rounded"></div>
        </div>

        <!-- Data, Previsto, Digitado -->
        <div
          v-for="cell in 3"
          :key="`text-${row}-${cell}`"
          class="h-3.5 w-16 bg-slate-200 rounded"
        ></div>

        <!-- Dif., Evid. -->
        <div v-for="cell in 2" :key="`num-${row}-${cell}`" class="flex justify-center">
          <div class="h-3.5 w-8 bg-slate-200 rounded"></div>
        </div>

        <!-- Tempo em fila -->
        <div class="h-3.5 w-12 bg-slate-200 rounded"></div>

        <!-- Status -->
        <div class="flex justify-start">
          <div class="h-6 w-24 bg-slate-200 rounded-full"></div>
        </div>

        <!-- Ações -->
        <div class="flex justify-center">
          <div class="h-8 w-8 rounded-full bg-slate-200"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// Skeleton só da TABELA: o load inicial e o refetch (troca de página/filtro)
// substituem apenas o grid, mantendo a barra de filtros montada.

withDefaults(
  defineProps<{
    // Espelha o tamanho de página da fila para evitar salto de layout.
    rows?: number
  }>(),
  { rows: 8 }
)

// Espelha o gridTemplateColumns das COLUMNS do módulo. Hardcoded de propósito para
// o componente não depender da ordem/largura do arquivo de constants.
const GRID_TEMPLATE_COLUMNS =
  '48px minmax(60px, 0.3fr) minmax(220px, 1.3fr) minmax(170px, 1fr) minmax(110px, 0.7fr) minmax(100px, 0.6fr) minmax(110px, 0.6fr) minmax(80px, 0.5fr) minmax(60px, 0.4fr) minmax(110px, 0.6fr) minmax(200px, 1fr) auto'

const HEADER_WIDTHS = ['w-6', 'w-16', 'w-28', 'w-24', 'w-16', 'w-16', 'w-8', 'w-10', 'w-24', 'w-14']

// Dif. (6) e Evid. (7) são centralizadas na tabela real.
const isCenteredHeader = (idx: number): boolean => idx === 6 || idx === 7
</script>
